// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"0b28c59d","443":"eb47bbfb","484":"0c7705b9","699":"f934c460","850":"838fddd8"}[chunkId] + ".chunk.js";
};